import styled from 'styled-components'

export const Wrap = styled.div`
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
`

export const Container = styled.div`
  margin: 1.5rem 0;
  font-size: 0.95rem;
  font-family: sans-serif;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  background-color: white;

  & thead {
    background: ${(props) => props.theme.gradients.primary};
    color: #ffffff;
    text-align: left;
  }

  & tr {
    transition: background-color 0.2s ease;
  }

  & tr:hover {
    background-color: #f8f9fa;
  }

  & tr:nth-of-type(even) {
    background-color: #f5f7fa;
  }

  & tr:nth-of-type(even):hover {
    background-color: #eef1f5;
  }

  & tr:last-of-type {
    border-bottom: none;
  }

  & td {
    vertical-align: middle;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #eaedf0;
  }

  & th {
    padding: 1.25rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    font-size: 0.85rem;
  }

  & > table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;

    @media screen and (max-width: 768px) {
      display: block;
      overflow-x: auto;
    }
  }
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`

export const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  color: #333;
  margin: 0;
`

export const Pop = styled.div``

export const PopUp = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`

export const PopUpContent = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  width: 650px;
  max-width: 95%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  & > button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background-color: transparent;
    border: none;
    color: #666;
    font-size: 1.5rem;
    cursor: pointer;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
    z-index: 10;

    &:hover {
      background-color: #f5f5f5;
      color: #333;
    }
  }
`

export const Coc = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`

export const RequestButton = styled.button`
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  background-color: ${(props) => props.theme.button.blue};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 100, 0.1);

  & svg {
    font-size: 1.25rem;
  }

  &:hover {
    background-color: ${(props) => props.theme.button.hoverBlue};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 100, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(0, 0, 100, 0.1);
  }
`

export const DaysCount = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background-color: #f5f7fa;
  border-radius: 8px;
  color: #555;
  font-weight: 500;
  border: 1px solid #eaedf0;

  & p {
    margin: 0;
    color: #555;
  }

  & span {
    font-weight: 600;
    color: ${(props) => props.theme.button.blue};
    font-size: 1.1rem;
  }
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1;

  &.pending {
    background-color: #fff8e6;
    color: #e6a700;
  }

  &.approved {
    background-color: #e6f7ed;
    color: #00a854;
  }

  &.rejected {
    background-color: #fff1f0;
    color: #f5222d;
  }

  &.cancelled {
    background-color: #e9f1ff;
    color: #2277e6;
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;

  & h3 {
    font-size: 1.25rem;
    color: #666;
    margin-bottom: 0.75rem;
  }

  & p {
    color: #888;
    margin-bottom: 1.5rem;
  }
`

export const DateCell = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  & svg {
    color: #aaa;
    font-size: 1rem;
  }
`

export const TypeBadge = styled.span`
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  background-color: #f5f7fa;
  color: #666;
  font-weight: 500;
`
